import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'
import { req, reqAuth } from '@/api/api_request'
import { csvObject, GetDistance } from '@/utils/util'
import { openMapWindow, addMarker, getTimeByType, calcMapcolor, getWindRecentTime } from '@/utils/util'
import { nuofang_gf_api, nuofang_gps_api } from "@/config/common"
const gf_base_url = process.env.DOCK_ENV ? nuofang_gf_api : 'http://gf.novaecs.com'
const gps_base_url = process.env.DOCK_ENV ? nuofang_gps_api : 'http://gps.novaecs.com'

const axios_base = req

// 获取客户端信息
function getClient(username) {
  return reqAuth.get(
    `anonymous/getClient?appId=14&serverName=${process.env.PROXY_TARGET || location.host}&username=${username}`,
    { auth: false }
  );
}

// 获取用户信息
function getAuthUserInfo(proId) {
  return reqAuth.get("auth/getUserInfo?proId=" + proId);
}

// 获取用户权限
function getUserMenuPower() {
  let url = `auth/getUserMenuPower?appId=14`;
  return reqAuth.get(url);
}

// 获取项目信息信息
function getProjectInfo(projectId) {
  return reqAuth.get(`auth/getProjectInfo?projectId=${projectId}`);
}

function login(data) {
  return axios.post('/api/wz_api_php/api/user/Login', data)
}

function getZhGroupByWz(wz_group_id) {
  return axios_base.get('user/getZhGroupByWz?wz_group_id=' + wz_group_id)
}

function getUserInfo() {
  return axios_base.get('user/getUserInfo')
}

function getProfile(profile_id) {
  return axios_base.get(`wz/getProfile/${profile_id}`)
}

function getStations(group_id) {
  return axios_base.get(`wz/getStations/${group_id}`)
}

function getVirtualStations(profile_id, group_id) {
  let url = `wz/getVirtualStations/${profile_id}?type=1,2,3&group_id=${group_id}`
  return axios_base.get(url)
}

function getUserVirStations() {
  return axios_base.get("session/getUserVirStations")
}

function getPollutionIndexArea({ start_t, end_t, sn, timeGroup }) {
  return axios_base.get(`pollution_index/getPollutionIndexArea?start_t=${start_t}&end_t=${end_t}&sn=${sn}&timeGroup=${timeGroup}`)
}

function getCapStationType(region_id) {
  let url = `${gf_base_url}/api/gf_manage/get_city_station_levels/?region_id=${region_id}&string=1&list=1`;
  // let url = `car_api_php/api/car_api/getCapStationType?city=${city}`
  return axios.get(url);
}

function getGfStations(regionId) {
  return axios.get(`${gf_base_url}/api/gf_manage/station/?region_id=${regionId}`)
}

function getGfDataWithTime({ time, time_type }) {
  return axios_base.get(`gf_data/getGfDataWithTime?city=济南&time=${time}&time_type=${time_type}`)
}


function getStationDataTimeSlot(params) {
  var url = `wz/getStationDataTimeSlot?data_type=${params.data_type}&time_type=${params.time_type}&station_id=${params.station_id}` +
    `&start_time=${params.start_time}&end_time=${params.end_time}`
  if (params.station_type) {
    url += `&station_type=${params.station_type}`
  }
  return axios_base.get(url).then(x => {
    var series_data = []
    var status = x.data.status
    if (status == 'ok') {
      var values = x.data.values
      for (var i of values) {
        series_data.push([i[0] * 1000, i[1]])
      }
      return series_data
    } else {
      return []
    }
  })
}

function getStationCurrentData(data_type, time_type) {
  return axios_base.get(`wz/getStationCurrentData?data_type=${data_type}&time_type=${time_type}`)
}

function getGfStationData(params) {
  if (params.data_type === 'co') {
    params.data_type = 'co_f'
  }
  let url = `${gf_base_url}/api/gf_manage/station_data/?start_t=${params.time}&data_type=${params.data_type}&time_type=${params.time_type}&region_id=${params.regionId}`
  return axios.get(url)
}

function getStationData(params) {
  let url = `wz/getStationData?station_type=${params.station_type}&time=${params.time}&data_type=${params.data_type}&time_type=${params.time_type}&city=${params.city}&group_id=${params.group_id}&profile_id=${params.profile_id}&data_calied_type=${params.data_calied_type}`
  return axios_base.get(url)
}

function getTimeStationData(params) {
  let url = `/station_data/getStationDataHour?time=${params.start_time}&hour=${params.hour}&data_type=${params.data_type}&group_id=${params.group_id}&time_type=${params.time_type}`
  return axios.get(url)
}

function getSingleStationData(time_type, station_id, time) {
  return axios_base.get(`wz/getSingleStationData?time_type=${time_type}&station_id=${station_id}&time=${time}`)
}

function getAlarmLogs(group_id) {
  return axios_base.get(`yc2/getGroupAlarmLogs?group_id=${group_id}`)
}

function getEvents() {
  return axios_base.get("/yc2/getPollutionEvent?userid=1526")
}

function getRegion(region_id) {
  // return axios.get(`http://yc.novaecs.com/calc/car_api_py/map_region_info3_api/get_map_region_member3?region_id=${region_id}`)
  return axios_base.get(`wz/getRegion/1?region_id=${region_id}`)
}

function getRegioninfo(group_id) {
  return axios.get('http://yc.novaecs.com/calc/car_api_py/map_region_info3_api/get_map_region_info3?group_id=' + group_id)
}

function getPollutionLevel(station_id) {
  return axios_base.get(`yc2/getPollutionLevel?station_id=${station_id}`)
}

function getPollutionHistory({ uid, timepoint, timeGroup }) {
  return axios_base.get(`pollution_index/getPollutionHistory?uid=${uid}&timepoint=${timepoint}&timeGroup=${timeGroup}`)
}
function getWZHistoryData({ uid, timepoint, maptype }) {
  return axios_base.get(`yc2/getWZHistoryData?uid=${uid}&timepoint=${timepoint}&maptype=${maptype}`)
}

function getStationHistory({ time_type, station_id, station_sn, start, end }) {
  let url = `/yc2/getStationHistory?timetype=${time_type}&startTime=${start}&endTime=${end}&sensortypes=pm25,pm10,wendu,shidu,noise,wind_speed,wind_direction`
  if (station_id) {
    url += `&station_id=${station_id}`
  }
  if (station_sn) {
    url += `&station_sn=${station_sn}`
  }
  return axios_base.get(url)
}

function getStationAlarmHistory(station_id, start, end) {
  return axios_base.get(`wz/getStationAlarms?station_id=${station_id}&start_time=${start}&end_time=${end}`)
}

function getNearStationAvg(dist = 1000, station_info, time_type, start_t, end_t) {
  var url = `yc2/getNearStationAvg?lng=${station_info.Lng}&lat=${station_info.Lat}&sn=${station_info.DevSN}&round=${dist}&timep=${time_type}&start_t=${start_t}&end_t=${end_t}`
  return axios_base.get(url).then(function (resp) {
    var data = resp.data.data
    var seriesDataPm25 = []
    var seriesDataPm10 = []
    for (var i in data) {
      if (data[i].time) {
        var pm25 = data[i].pm25
        var pm10 = data[i].pm10
        seriesDataPm25.push([data[i].time - 3600 * 8 * 1000, pm25])
        seriesDataPm10.push([data[i].time - 3600 * 8 * 1000, pm10])
      }
    }
    let d1 = { id: 'compare1_pm25', name: '附近' + dist / 1000 + 'km(' + resp.data.sninfo.length + ') PM₂.₅', data: seriesDataPm25 }
    let d2 = { id: 'compare1_pm10', name: '附近' + dist / 1000 + 'km(' + resp.data.sninfo.length + ') PM₁₀', data: seriesDataPm10 }
    return { pm25: d1, pm10: d2 }
  }).catch(function (e) {
    console.log(e)
    // anotherData = {id:2,name:'附近'+dist/1000+'公里设备均值(' + resp.data.sninfo.length + ')', data:[], color:self.anotherColor}
  })
}

function getGrid() {
  return axios_base.get(`yc2/getBoxMember`).then(x => {
    return axios_base.get(`yc2/getBoxInfo`).then(y => {
      let memberData = x.data
      let gridData = y.data
      let realtion = {}
      for (var m in memberData) {
        for (var i in gridData) {
          if (memberData[m].box_name == gridData[i].name) {
            if (realtion[gridData[i].id]) {
              realtion[gridData[i].id].arr.push(memberData[m].station_id)
            } else {
              realtion[gridData[i].id] = {
                arr: [memberData[m].station_id],
                pm25: 0,
                pm10: 0,
                name: memberData[m].box_name
              }
            }
            break;
          }
        }
      }
      return [gridData, realtion]
    })
  })

}

function filter_grid(grid_list) {
  let lng_list = []
  let lat_list = []
  for (let i of grid_list) {
    if (lng_list.indexOf(i.lng) == -1) {
      lng_list.push(i.lng)
    }
    if (lat_list.indexOf(i.lat) == -1) {
      lat_list.push(i.lat)
    }
  }
  lng_list.sort()
  lat_list.sort()
  let lng_filter = []
  let lat_filter = []
  for (let g in lng_list) {
    if ((g - 1) % 3 == 0) {
      lng_filter.push(lng_list[g])
    }
  }
  for (let t in lat_list) {
    if ((t - 1) % 3 == 0) {
      lat_filter.push(lat_list[t])
    }
  }
  let filter_grid = []

  var w = 0.0055559 * 3
  var j = 0.0045245 * 3

  for (let g of grid_list) {
    let i = _.cloneDeep(g)
    let lng = i.lng
    let lat = i.lat
    let arr = []
    var lat1 = lat + j
    var lat2 = lat - j
    var lng1 = lng + w
    var lng2 = lng - w
    arr[0] = lng1
    arr[2] = lat1
    arr[1] = lng2
    arr[3] = lat2

    if (lng_filter.indexOf(i.lng) != -1 && lat_filter.indexOf(i.lat) != -1) {
      i.grid_type = 'grid3'
      let child_grids = []
      for (let r of grid_list) {
        let r_lng = r.lng
        let r_lat = r.lat
        if (r_lng < arr[0] && r_lng > arr[1] && r_lat < arr[2] && r_lat > arr[3]) {
          child_grids.push(r)
          if (r.hot_point == 1) {
            i.hot_point = 1
          }
          if (child_grids.length >= 9) {
            break;
          }
        }
      }
      i.child_grids = child_grids
      filter_grid.push(i)
    }
  }
  return filter_grid
}

function getGridsOld() {
  return axios_base.get('wz/getGrid').then(x => {
    let al_grid = x.data
    let f1 = filter_grid(al_grid, 'lng', 'lat')
    return { grid1: al_grid, grid3: f1 }
  })
}

function getGrids() {
  return axios_base.get('wz/getGridNew').then(x => {
    let al_grid = x.data

    return { grid1: al_grid.grid1, grid3: al_grid.grid3 }
  })
}

function getPmcolorRatio() {
  return axios.get(gps_base_url + "/api/misc/getPmcolorRatio")
}

function getStationByVir(vir_id) {
  return axios_base.get(`wz/getStationByVir?vir_id=${vir_id}`).then(x => {
    return x.data.map(function (x) {
      return x.station_id
    })
  })
}

function getWindDataFun(params_wind_speed, params_wind_direction, gf_stations) {
  return getStationData(params_wind_speed).then(c => {    // 风速
    let wind_data = []
    let wind_speed_data = c.data.values
    return getStationData(params_wind_direction).then(d => {    // 风向
      let wind_direction_data = d.data.values
      let columns = d.data.columns
      let station_id_idx = columns.indexOf('station_id')
      for (let i of wind_speed_data) {
        let wind_d = {}
        let station_id = i[station_id_idx]
        let station_info = _.find(gf_stations, function (x) { return x.station_id == station_id })
        let dir_data = _.find(wind_direction_data, function (x) { return x[station_id_idx] == station_id })
        if (!dir_data) {
          continue
        }
        wind_d.station_info = station_info
        wind_d.wind_speed = i[1]
        wind_d.wind_direction = dir_data[1]
        // wind_d.wind_direction = 1
        if (wind_d.wind_speed && wind_d.wind_direction) {
          wind_data.push(wind_d)
        }
      }
      return wind_data
    })
  })
}

function getWindFromEarth(city, time, gf_stations) {
  // return getWindDataFromCity(time)
  // 2019.9.5 18
  // if (time > 1567677600000) {
  //   return getWindDataFromOss(time);
  // }
  // return getWindDataFromCity(time)
  time = getWindRecentTime(time)
  return axios_base.get(`wz/getGfWind?time=${time}`).then(x => {
    let data = x.data
    // let wind_data = []
    // for(let i of data){
    //   let wind_d = {}
    //   let station_id = i.sn
    //   let station_info = _.find(gf_stations,function(x){return x.station_id == station_id})
    //   wind_d.station_info = station_info
    //   wind_d.wind_speed = i.wind_speed
    //   wind_d.wind_direction = i.wind_direction
    //   if (wind_d.wind_speed && wind_d.wind_direction){
    //     wind_data.push(wind_d)
    //   }
    // }
    // return wind_data
    let wind_data = []
    for (let i of data) {
      let gcj = coordtransform.wgs84togcj02(i.station_info.gisx, i.station_info.gisy)
      let bd = coordtransform.gcj02tobd09(gcj[0], gcj[1])
      i.Lng = bd[0]
      i.Lat = bd[1]
      wind_data.push([bd[0], bd[1], i.wind_direction, i.wind_speed])
    }
    return wind_data
  })
}

function getGfAvg({ time_type, start, end, gf_level, data_type, region_id }) {
  // let url = `yc2/getGfAvg?timep=${type}&start_t=${start}&end_t=${end}`
  // if (type){
  //   url += `&type=${gf_level}`
  // }
  // return axios_base.get(url).then(x=>{
  //   var seriesData = []
  //   for (var i of x.data){
  //     if (i.time){
  //       var v = i[data_type]
  //       seriesData.push([i.time - 3600*1000*8, v])
  //     }
  //   }
  //   return seriesData
  // })
  let url = `${gf_base_url}/api/gf_manage/dataStatisticsList/?start_t=${start}&end_t=${end}&data_type=${data_type}&region_id=${region_id}&time_type=${time_type}`
  return axios.get(url).then(x => {
    let d = x.data.data
    let seriesData = []
    for (var i of d) {
      seriesData.push([i.data_time * 1000, i[data_type]])
    }
    return seriesData
  })
}

function getGfHistory({ start, end, sn, type, pres, name }) {
  return axios_base.get(`gf_data/getGfDataHistory?start=${start}&end=${end}&sn=${sn}&type=${type}&pres=${pres}`).then(x => {
    return { name: name, data: x.data[0].values }
  })
}

function getNearGfData({ lat, lng, start, end, type, pres }) {
  var gcj = coordtransform.bd09togcj02(lng, lat)
  var wgs = coordtransform.gcj02towgs84(gcj[0], gcj[1])
  return axios.get(`http://api.novaecs.com/getNearbyGFStation.php?lat=${wgs[1]}&lng=${wgs[0]}`).then(x => {
    let data = x.data.data
    if (!data.length) { return [] }
    return getGfHistory({ start: start, end: end, sn: data[0].sid, type: type, pres: pres, name: data[0].station })
  })
}

function getBorder(params) {
  return axios.get('http://yc.novaecs.com/calc/car_api_py/map_region_info3_api/get_map_region_member3?region_id=10001')
}

function getRouteDustIndex({ start, end, data_type, time_type, group_id, host }) {
  return axios.get(`http://${host}/api/car_api_php/api/car_api/getRouteDustIndex?data_type=${data_type}&start=${start}&end=${end}&group_id=${group_id}&time_type=${time_type}`).then(x => {
    var series_data = []
    var values = x.data.values
    for (var i of values) {
      series_data.push([i[0] * 1000, i[1]])
    }
    return series_data
  })
}

function getWindDataFromOss(time) {
  let t = moment(time).format('YYYY-MM-DD HH:00:00')
  return axios.get(`https://weatherdata0.oss-cn-beijing.aliyuncs.com/${moment(time).format('YYYY')}/${moment(time).format('YYYY-MM')}/${moment(time).format('YYYY-MM-DD')}/${moment(time).format('YYYY-MM-DD_HH')}.csv`).then(x => {
    let windData = [

    ]
    let data = csvObject(x.data)
    let exsit = {}
    for (let i of data) {
      if (isNaN(parseFloat(i.longitude)) || isNaN(parseFloat(i.latitude)) || isNaN(parseFloat(i.wind_speed)) || isNaN(parseFloat(i.wind_direction))) {
        continue
      }

      let key = Math.round(parseFloat(i.longitude) * 10) / 10 + ':' + Math.round(parseFloat(i.latitude) * 10) / 10
      if (exsit[key] == 1) {
        continue
      }
      exsit[key] = 1
      // let bd = [parseFloat(i.longitude),parseFloat(i.latitude)]
      let gcj = coordtransform.wgs84togcj02(parseFloat(i.longitude), parseFloat(i.latitude))
      let bd = coordtransform.gcj02tobd09(gcj[0], gcj[1])
      console.log(bd)
      console.log(parseFloat(i.longitude), parseFloat(i.latitude))
      let d = [parseFloat(i.longitude), parseFloat(i.latitude), parseFloat(i.wind_speed), parseFloat(i.wind_direction_degree)]

      windData.push(d)
    }
    return windData
  })
}

function getWindDataFromCity(time) {
  let t = moment(time).format('YYYY-MM-DD HH:00:00')
  return axios.get(`http://yc.novaecs.com/gps/api/gf/get_gf_data?month=1小时叠加:${t}:ALLPOINT&snstr=CN37-1203-gangcheng,CN37-1202-laicheng`).then(x => {
    let windData = []
    let snCoord = {
      'CN37-1203-gangcheng': [117.98992151800628, 35.83052816847547],
      'CN37-1202-laicheng': [117.34436198505721, 36.24761774137943]
    }
    let data = x.data

    for (let i of data) {
      let coord = snCoord[i.devId]
      windData.push([
        coord[0], coord[1], i.wind_direction, 2
      ])
    }
    return windData
  })
}

function getStationDiff({ start, end }) {
  let url = `/api/data_audit/stat_wz/stationPollutionIndexDeviation?start_dt=${start}&end_dt=${end}`
  return axios.get(url)
}

function getCalGroups() {
  return req.get(`yc2/gps_cali/GetCalGroups`)
}

function GetCalGroupStations(dyn_group_id) {
  return req.get(`yc2/gps_cali/GetCalGroupStations?group_id=${dyn_group_id}`)
}

// 创建快照
function saveSnapshot(data) {
  let url = `/api/data_audit/pollution_analysis_snapshot/`
  return axios.post(url, data)
}

// 获取快照列表
function getSnapshotList({ group_id }) {
  let url = `/api/data_audit/pollution_analysis_snapshot/?group_id=${group_id}`
  return axios.get(url)
}

// 获取快照详情
// function saveSnapshot(data) {
//   let url = `/api/data_audit/pollution_analysis_snapshot/`
//   return axios.post(url, data)
// }

// 获取快照数据
function getSnapshotData({ group_id, name, station_type, time, time_type, data_type }) {
  let url = `/api/data_audit/pollution_analysis_snapshot/data/?group_id=${group_id}&name=${name}&station_type=${station_type}&time=${time}&time_type=${time_type}&data_type=${data_type}`
  return axios.get(url)
}

// 删除快照
function archiveSnapshot(id) {
  let url = `/api/data_audit/pollution_analysis_snapshot/${id}/`
  return axios.delete(url)
}
// 标站污染指数
function getStationPollutionIndex(dt, time_type) {
  const baseUrl = process.env.DOCK_ENV ? `${nuofang_gf_api}/api` : 'http://gf.novaecs.com:8001'
  return axios.get(`${baseUrl}/gf_manage/pollutionIndex/?dt=${dt}&time_type=${time_type}`)
    .then(res => res.data)
    .catch(err => console.log(err))
}

// 获取09参数微站数据
function get029Wz({ time, data_type, group_id, time_type }) {
  const url = `http://jnwz.novaecs.com/172/py5010/get-029-device-data-by-groupid?group_id=${group_id}&data_type=${data_type}&time_type=${time_type}&time=${time}`
  return axios.get(url)
}

// 获取029设备风玫瑰图数据
function get029Wind({ start_time, end_time, city, type, stationType, level }) {
  var url = `http://xinzhi-weather.it.czczh.cn/get-station-data?start_time=${start_time}&end_time=${end_time}&city=${city}&type=${type}&map_dist_m=20`
  // var url = `/get-station-data?start_time=${start_time}&end_time=${end_time}&city=${city}&type=${type}&map_dist_m=20`
  if (stationType == 'bzRadio') {
    url += `&level=国,省,市,街镇,交通站`
  }
  return axios.get(url)
}

//获取污染分析接口2022.1.27
function set_info_pollute(data) {
  let url = `/pollution_reptile/api/data_audit_test/set_info_pollute`
  return axios.post(url, data)
}

function getRecent24hourPolluteSource(data_type) {
  return axios.get(`/mapi/pollution/${data_type}/days/1/top_k/1000`)
}

export {
  getClient,
  getAuthUserInfo,
  getUserMenuPower,
  getProjectInfo,
  login,
  getUserInfo,
  getProfile,
  getStations,
  getVirtualStations,
  getUserVirStations,
  getGfStations,
  getStationDataTimeSlot,
  getStationData,
  getTimeStationData,
  getAlarmLogs,
  getStationCurrentData,
  getEvents,
  getSingleStationData,
  getRegion,
  getRegioninfo,
  getPollutionLevel,
  getStationHistory,
  getStationAlarmHistory,
  getNearStationAvg,
  getGrid,
  getGrids,
  getPmcolorRatio,
  getStationByVir,
  getWindDataFun,
  getWindFromEarth,
  getGfAvg,
  getGfHistory,
  getNearGfData,
  getPollutionIndexArea,
  getGfDataWithTime,
  getPollutionHistory,
  getWZHistoryData,
  getBorder,
  getRouteDustIndex,
  getZhGroupByWz,
  getWindDataFromOss,
  getWindDataFromCity,
  getGfStationData,
  getStationDiff,
  getCalGroups,
  GetCalGroupStations,
  saveSnapshot,
  getSnapshotList,
  getSnapshotData,
  archiveSnapshot,
  getStationPollutionIndex,
  getCapStationType,
  get029Wz,
  get029Wind,
  set_info_pollute,
  getRecent24hourPolluteSource
}



// WEBPACK FOOTER //
// ./src/api/api.js